import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Input.scss';


const Input = ({ variantClasses = [], id, type, value = '', readOnly, inputChange, inputFocus = () => {}, inputBlur = () => {}, isError = false, placeholder = ' ', defaultValue = '', label = null, ...props }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const inputFocusHandler = (e) => {
		const $input = e.currentTarget;
		inputFocus($input.id, $input.value);
	};

	const inputClasses = [s.input];
	const labelClasses = [s.label];

	if (value !== '') inputClasses.push(s.input__filled);

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else inputClasses.push(s[c]);
	});

	if (isError) {
		labelClasses.push(s.label__error);
		inputClasses.push(s.input__error);
	}

	if (readOnly) props.tabIndex = -1;

	const input = <input className={inputClasses.join(' ')} id={id} name={id} readOnly={readOnly} type={type} value={value || defaultValue} placeholder={placeholder} onChange={inputChangeHandlar} onFocus={inputFocusHandler} onBlur={inputBlurHandler} {...props} />;

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				{ input }
				<span className={s.label_text}>
					{ label }
					{ typeof isError === 'string' && <span className={s.label_text_error}> { isError }</span> }
				</span>
			</label>
		);
	}
	return input;
};

export default hot(module)(Input);
